import { SxProps } from "@mui/material";
import { getColors } from "../../utils";

export const headerBox: SxProps = {
  display: "flex",
  padding: "var(--Spacing-Spacing-20, 20px) 16px",
  alignItems: "center",
  gap: "16px",
  alignSelf: "stretch",
  justifyContent: "space-between",
};

export const bodyBox: SxProps = {
  display: "flex",
  padding: "0px 20px 20px",
  flexDirection: "column",
  gap: "40px",
  alignSelf: "stretch",
  minHeight: 0,
  overflowY: "auto",
  WebkitOverflowScrolling: "touch",
};

export const formWrapper: SxProps = {
  display: "flex",
  flexDirection: "column",
  gap: 5,
  width: "100%",
};

export const rowBox: SxProps = {
  display: "flex",
  gap: 5,
  width: "100%",
  flexDirection: {
    xs: "column",
    sm: "column",
    md: "row",
  },
};

export const deleteButtonBox: SxProps = {
  display: "flex",
  justifyContent: "center",
  gap: 2,
  flexWrap: "wrap",
  mt: 2,
};

export const passwordBox: SxProps = {
  display: "flex",
  alignItems: "flex-start",
  gap: "20px",
  alignSelf: "stretch",
  flexDirection: {
    xs: "column",
    sm: "column",
    md: "row",
  },
};
export const content: SxProps = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  gap: "8px",
  alignSelf: "stretch",
};
export const getActionContainer = () => {
  return {
    display: "flex",
    padding: "20px",
    alignItems: "flex-start",
    gap: "20px",
    borderRadius: 2,
    width: "100%",
    color: getColors().text,
    height: "auto",
    minHeight: 0,
  };
};
